import { SaveOutlined, UserAddOutlined } from "@ant-design/icons";
import { Alert, App, Button, Col, Form, Input, Modal, Row, Space } from "antd";
import { useState } from "react";
import ECard from "./components/ECard";
import ETable from "./components/ETable";
import ETag from "./components/ETag";
import InlineCopyable from "./components/InlineCopyable";
import { Curl, ISO8601 } from "./components/Jarvis";

export default function UsersPage() {
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  const { notification } = App.useApp();
  const [forceUpdate, setForceUpdate] = useState(1);

  const handleSubmit = (values) => {
    Curl.post("/gateway/resources/users", values)
      .then((res) => {
        setOpen(false);
        notification.success({
          message: "User Creation",
          description: `Invitation Email have been sent to ${values.username}.`,
        });
        setForceUpdate((c) => c + 1);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ECard
          title="Users"
          extra={
            <Space>
              <Button
                type="primary"
                icon={<UserAddOutlined />}
                onClick={() => {
                  setOpen(true);
                }}
              >
                Create User
              </Button>
            </Space>
          }
        >
          <ETable
            name={["users"]}
            uri="/gateway/resources/users"
            forceUpdate={forceUpdate}
            columns={[
              {
                title: "Username",
                align: "center",
                render: (item) => {
                  return <InlineCopyable>{item.username}</InlineCopyable>;
                },
              },
              {
                title: "Last Login IP",
                align: "center",
                render: (item) => {
                  return item.last_login_ip;
                },
              },
              {
                title: "Last Login at",
                align: "center",
                render: (item) => {
                  return ISO8601(item.last_login_at);
                },
              },
              {
                title: "Status",
                align: "center",
                render: (item) => {
                  return <ETag>{item.status}</ETag>;
                },
              },
              {
                title: "Created at",
                align: "center",
                render: (item) => {
                  return ISO8601(item.created_at);
                },
              },
            ]}
          />
        </ECard>
        <Modal
          open={open}
          title="Create User"
          onCancel={() => {
            setOpen(false);
          }}
          onOk={() => {
            form.submit();
          }}
          okButtonProps={{
            icon: <SaveOutlined />,
          }}
        >
          <Space direction="vertical">
            <Alert
              type="info"
              showIcon
              message="Invitation Email with subject: `User Account Invitation` with a verification link will be send to the user, user should check their Inbox to activate their account and setup the password."
            />
            <Form
              form={form}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              colon={false}
              onFinish={handleSubmit}
            >
              <Form.Item
                label="Email Address"
                name="username"
                rules={[{ required: true }, { type: "email" }]}
              >
                <Input />
              </Form.Item>
            </Form>
          </Space>
        </Modal>
      </Col>
    </Row>
  );
}
